<template>
  <TsCard appendClass="w-full py-9" :data-testid="props.dataTestid">
    <div class="w-full mb-3">
      <div class="h-44 w-44 m-auto">
        <TsImage class="m-auto rounded-full h-full w-full object-cover" :src="image" :data-testid="props.dataTestid + '-img'" loading="lazy"/>
      </div>
      <div class="mt-10 px-3">
        <TsTypography as="h1" variant="h2" appendClass="text-natural-grey dark:text-gray-400 py-2 text-xl font-bold text-left">
          {{title}}
        </TsTypography>
        <p class="text-natural-grey dark:text-gray-400 text-left mt-1" v-html="description">
        </p>
      </div>
    </div>
  </TsCard>
</template>

<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Props = {
  title?: string;
  description?: object;
  image?: string;
  alt?: string | number;
  dataTestid:string;
}

const props = withDefaults(defineProps<Props>(), {
});
</script>

